let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2DZcv")).then(() => parcelRequire('eg69Y'));